<p *ngIf="environmentName" class="environment-indicator">
  {{ environmentName }}
</p>
